import ControlArea from "components/Layout/ControlArea";
import React, { useEffect } from "react";
import Table from "./Table";
import shareIcon from "assets/svgs/services.svg";
import { useDispatch } from "react-redux";
import { getServices } from "store/actions";
const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getServices());
  }, [dispatch]);

  return (
    <>
      <div className="users-wrap">
        <ControlArea
          btnTxt="اضافة خدمة جديدة"
          cardTxt="الخدمات"
          icon={shareIcon}
          url="/services/add"
        />
        <Table />
      </div>
    </>
  );
};

export default Index;
